(() => {
  const sections = document.querySelectorAll('[data-nel-rtw-section]');
  sections.forEach((section) => {
    const all = (selector) => Array.from(section.querySelectorAll(selector));
    const one = (selector) => section.querySelector(selector);

    const imageMain = one('.image-main');
    const mediaSlides = all('[data-nel-slide]');
    const setActiveMediaRatio = (id) => {
      if (!imageMain) return;
      const slide = mediaSlides.find((item) => item.dataset.nelSlide === String(id)) || mediaSlides.find((item) => item.classList.contains('active'));
      const ratio = slide?.dataset?.nelRatio;
      if (ratio) imageMain.style.setProperty('--nel-active-media-ratio', ratio);
    };
    setActiveMediaRatio(mediaSlides.find((item) => item.classList.contains('active'))?.dataset?.nelSlide || '0');

    all('[data-nel-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.nelThumb;
        all('[data-nel-thumb]').forEach((el) => el.classList.toggle('active', el === thumb));
        all('[data-nel-slide]').forEach((slide) => slide.classList.toggle('active', slide.dataset.nelSlide === id));
        setActiveMediaRatio(id);
      });
    });

    const priceCurrent = one('[data-nel-price-current]');
    const priceCompare = one('[data-nel-price-compare]');
    const priceSale = one('[data-nel-price-sale]');
    const sizeSummary = one('[data-nel-size-summary]');
    const selectedMeasurement = one('[data-nel-selected-measurement]');
    const chosenSize = one('[data-nel-chosen-size]');
    const variantInput = one('[data-nel-variant-input]');
    const submitButton = one('[data-nel-submit]');
    const submitLabel = one('[data-nel-submit-label]');
    const addLabel = submitButton ? submitButton.dataset.addLabel : 'Add to Cart';
    const soldOutLabel = submitButton ? submitButton.dataset.soldOutLabel : 'Sold out';

    const form = one('form.nel-form');
    const errorWrapper = one('.product-form__error-message-wrapper');
    const errorMessage = one('.product-form__error-message');
    const customSizeButton = one('[data-nel-custom-size]');
    const customSizePanel = one('[data-nel-custom-size-panel]');
    const customSizeProperty = one('[data-nel-custom-size-property]');
    const customSizeFields = all('[data-nel-custom-size-field]');
    const customSizeRequiredFields = all('[data-nel-custom-size-required]');

    const setFormError = (message) => {
      if (errorMessage) errorMessage.textContent = message;
      if (errorWrapper) errorWrapper.hidden = !message;
    };

    const setCustomSizeEnabled = (enabled) => {
      if (customSizePanel) customSizePanel.hidden = !enabled;
      if (customSizeProperty) customSizeProperty.disabled = !enabled;
      customSizeFields.forEach((field) => {
        field.disabled = !enabled;
        if (!enabled) field.value = '';
      });
      customSizeRequiredFields.forEach((field) => {
        field.required = enabled;
        field.setAttribute('aria-required', enabled ? 'true' : 'false');
      });
      if (!enabled) setFormError('');
    };

    const setCustomButtonStyle = () => {};


    const syncVariantButtonStyles = () => {};
    syncVariantButtonStyles();

    all('[data-nel-variant]').forEach((button) => {
      button.addEventListener('click', () => {
        all('[data-nel-variant]').forEach((el) => {
          el.classList.remove('active');
          el.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');
        if (customSizeButton) {
          customSizeButton.classList.remove('active');
          customSizeButton.setAttribute('aria-pressed', 'false');
        }
        setCustomSizeEnabled(false);
        syncVariantButtonStyles();

        const title = button.dataset.title;
        const display = button.dataset.display || title;
        const available = button.dataset.available === 'true';
        const price = Number(button.dataset.price || 0);
        const compareAt = Number(button.dataset.compareAt || 0);

        if (sizeSummary) {
          const label = button.dataset.sizeLabel || 'Choose Your Size:';
          const measurement = button.dataset.measurement || '';
          sizeSummary.textContent = `${label} ${display}${measurement ? ` ${measurement}` : ''}`;
        }
        if (selectedMeasurement) selectedMeasurement.textContent = button.dataset.measurement || '';
        if (chosenSize) chosenSize.textContent = display;
        if (variantInput) variantInput.value = button.dataset.variantId;
        if (priceCurrent) priceCurrent.textContent = button.dataset.priceMoney;
        if (priceCompare) {
          priceCompare.textContent = button.dataset.compareMoney || '';
          priceCompare.hidden = !(compareAt > price);
        }
        if (priceSale) {
          const percent = compareAt > price ? Math.round(((compareAt - price) * 100) / compareAt) : 0;
          priceSale.textContent = percent ? `Save ${percent}%` : '';
          priceSale.hidden = !percent;
        }
        if (submitButton) submitButton.disabled = !available;
        if (submitLabel) submitLabel.textContent = available ? addLabel : soldOutLabel;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', button.dataset.variantId);
        window.history.replaceState({}, '', url.toString());
      });
    });


    customSizeButton?.addEventListener('click', () => {
      all('[data-nel-variant]').forEach((el) => {
        el.classList.remove('active');
        el.setAttribute('aria-pressed', 'false');
      });
      customSizeButton.classList.add('active');
      customSizeButton.setAttribute('aria-pressed', 'true');
      setCustomSizeEnabled(true);
      syncVariantButtonStyles();

      const label = customSizeButton.dataset.sizeLabel || 'Choose Your Size:';
      if (sizeSummary) sizeSummary.textContent = `${label} Custom size`;
      if (selectedMeasurement) selectedMeasurement.textContent = 'Custom size';
      if (chosenSize) chosenSize.textContent = 'Custom size';
      if (variantInput && customSizeButton.dataset.baseVariantId) variantInput.value = customSizeButton.dataset.baseVariantId;
      if (submitButton) submitButton.disabled = false;
      if (submitLabel) submitLabel.textContent = addLabel;
      customSizeRequiredFields[0]?.focus({ preventScroll: false });
    });

    form?.addEventListener('submit', (event) => {
      const customActive = customSizeButton?.classList.contains('active') || customSizeButton?.getAttribute('aria-pressed') === 'true';
      if (!customActive) return;
      const emptyField = customSizeRequiredFields.find((field) => !field.value.trim());
      if (!emptyField) {
        setFormError('');
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      setFormError('Please enter both left and right hand measurements for custom size.');
      emptyField.focus({ preventScroll: false });
    }, true);

    const quantity = one('[data-nel-quantity]');
    const changeQuantity = (delta) => {
      if (!quantity) return;
      const current = Number(quantity.value || 1);
      quantity.value = Math.max(1, current + delta);
    };
    one('[data-nel-minus]')?.addEventListener('click', () => changeQuantity(-1));
    one('[data-nel-plus]')?.addEventListener('click', () => changeQuantity(1));

    const modal = one('[data-nel-guide-modal]');
    const closeModal = () => {
      if (!modal) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nel-modal-open');
      one('[data-nel-guide-open]')?.focus({ preventScroll: true });
    };
    const openModal = () => {
      if (!modal) return;
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nel-modal-open');
      modal.scrollTop = 0;
      const card = modal.querySelector('.guide-card');
      if (card) card.scrollTop = 0;
      modal.querySelector('[data-nel-guide-close]')?.focus({ preventScroll: true });
      modal.dataset.previouslyFocused = document.activeElement ? '1' : '';
      modal.dataset.previouslyFocused = document.activeElement ? '1' : '';
    };
    one('[data-nel-guide-open]')?.addEventListener('click', openModal);
    one('[data-nel-guide-close]')?.addEventListener('click', closeModal);
    modal?.addEventListener('click', (event) => { if (event.target === modal) closeModal(); });
    document.addEventListener('keydown', (event) => {
      if (!modal?.classList.contains('open')) return;
      if (event.key === 'Escape') closeModal();
      if (event.key !== 'Tab') return;
      const focusables = Array.from(modal.querySelectorAll('button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])')).filter((el) => !el.disabled && el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });
})();
